var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useContext } from "react";
import { ChevronDownIcon } from "@navikt/aksel-icons";
import { useRenameCSS, useThemeInternal } from "../theme/Theme.js";
import { Heading } from "../typography/index.js";
import { composeEventHandlers } from "../util/composeEventHandlers.js";
import { AccordionContext } from "./AccordionContext.js";
import { AccordionItemContext } from "./AccordionItem.js";
const AccordionHeader = forwardRef((_a, ref) => {
    var _b;
    var { children, className, onClick } = _a, rest = __rest(_a, ["children", "className", "onClick"]);
    const itemContext = useContext(AccordionItemContext);
    const accordionContext = useContext(AccordionContext);
    const themeContext = useThemeInternal(false);
    const { cn } = useRenameCSS();
    if (itemContext === null) {
        console.error("<Accordion.Header> has to be used within an <Accordion.Item>, which in turn must be within an <Accordion>");
        return null;
    }
    let headingSize = (_b = accordionContext === null || accordionContext === void 0 ? void 0 : accordionContext.headingSize) !== null && _b !== void 0 ? _b : "small";
    if (themeContext) {
        /* Fallback to "medium" Accordion-size if any other sizes are used */
        headingSize = (accordionContext === null || accordionContext === void 0 ? void 0 : accordionContext.size) === "small" ? "xsmall" : "small";
    }
    return (React.createElement("button", Object.assign({ ref: ref }, rest, { className: cn("navds-accordion__header", className), onClick: composeEventHandlers(onClick, itemContext.toggleOpen), "aria-expanded": itemContext.open, type: "button" }),
        React.createElement("span", { className: cn("navds-accordion__icon-wrapper") },
            React.createElement(ChevronDownIcon, { className: cn("navds-accordion__header-chevron"), "aria-hidden": true })),
        React.createElement(Heading, { size: headingSize, as: "span", className: cn("navds-accordion__header-content") }, children)));
});
export default AccordionHeader;
//# sourceMappingURL=AccordionHeader.js.map